import React from 'react'

const ClipBoardIcon = () => {
  return (
    <svg
      width="10"
      height="31"
      viewBox="0 0 10 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99989 25.9878C6.87161 25.9878 8.38893 24.4705 8.38892 22.5987L8.3888 8.69065C8.3888 8.41451 8.61266 8.19064 8.8888 8.19064C9.16494 8.19064 9.3888 8.4145 9.3888 8.69064L9.38892 22.5987C9.38894 25.0227 7.4239 26.9878 4.99989 26.9878C2.57591 26.9878 0.610885 25.0228 0.610868 22.5988L0.610767 7.31606C0.610753 5.47785 2.10091 3.98767 3.93913 3.98767C5.77733 3.98767 7.26749 5.47782 7.2675 7.31602L7.26755 20.2199C7.26756 21.4723 6.25224 22.4876 4.99978 22.4876C3.74734 22.4876 2.73202 21.4723 2.73202 20.2199L2.73195 8.69065C2.73195 8.4145 2.9558 8.19064 3.23194 8.19064C3.50809 8.19064 3.73195 8.4145 3.73195 8.69064L3.73202 20.2199C3.73202 20.92 4.29962 21.4876 4.99978 21.4876C5.69996 21.4876 6.26756 20.92 6.26755 20.2199L6.2675 7.31603C6.26749 6.03011 5.22505 4.98767 3.93913 4.98767C2.6532 4.98767 1.61076 6.03013 1.61077 7.31605L1.61087 22.5988C1.61088 24.4705 3.12819 25.9878 4.99989 25.9878Z"
        fill="#5D7290"
      />
    </svg>
  )
}

export default React.memo(ClipBoardIcon)
